import { Badge } from '@/components/ui/badge';
import { ReceivingItemTypeEnum } from '../types/receiving.types';

/**
 * Renders a single item-type label for a receiving line item, always showing
 * exactly one of: Service, Lot, Serial, or Inventory (the plain InvtPart that
 * is neither lot- nor serial-tracked). Source of the value:
 * ReceivingDocumentItems.ItemType (synced from NetSuite item.islotitem/isserialitem).
 */
export function ItemTypeBadge({
  item,
  className,
}: {
  item: { isServiceItem: boolean; itemType: ReceivingItemTypeEnum };
  className?: string;
}) {
  const base = `whitespace-nowrap${className ? ` ${className}` : ''}`;
  if (item.isServiceItem) {
    return <Badge variant="outline" className={`border-warning/30 text-warning ${base}`}>Service</Badge>;
  }
  if (item.itemType === ReceivingItemTypeEnum.LotNumbered) {
    return <Badge variant="secondary" className={base}>Lot</Badge>;
  }
  if (item.itemType === ReceivingItemTypeEnum.Serialized) {
    return <Badge variant="outline" className={base}>Serial</Badge>;
  }
  return <Badge variant="outline" className={`text-muted-foreground ${base}`}>Inventory</Badge>;
}
